import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';
import qs from 'query-string';

const DataApiUrl = dataApiUrl();

const DistributionJobs = () => {
  const history = params =>
    AuthAxios.get(
      qs.stringifyUrl({
        url: `${DataApiUrl}/admin/distributionJobs`,
        query: {
          search: params.upc ? undefined : params.search || '',
          upc: params.upc || undefined,
          dsp: params.selectedDsp || undefined,
          page_size: params.pageSize || 50,
          page_index: params.page || 0,
        },
      })
    )
      .then(res => res.data?.data)
      .catch(err => {
        throw err.response;
      });

  const getFileUrl = (id, type) =>
    AuthAxios.get(
      qs.stringifyUrl({
        url: `${DataApiUrl}/admin/distributionJobs/${id}/fileUrl`,
        query: {
          type,
        },
      })
    )
      .then(res => {
        return { ...res.data?.data, type };
      })
      .catch(err => {
        throw err.response;
      });

  return {
    history,
    getFileUrl,
  };
};

export default DistributionJobs;
